import * as React from 'react';
import { useParams } from 'react-router-dom';
import { SimpleProcessor } from './components/SimpleProcessor';

export const TimetableAmend = (): React.JSX.Element => {
  const params = useParams();
  return <SimpleProcessor timetableId={Number(params.key)} />;
};
